/**
 * Returns true if New Plans are available.
 * Plans for the new year are available on Oct 1st to the end of AEP 12/07.
 * Can be overridden by environment variable IS_AEP.
 * @returns boolean: if in AEP or not.
 */
export default function isPreAep(): boolean {
  if (process.env.IS_AEP !== undefined) {
    return process.env.IS_AEP === 'true';
  }

  const today = new Date();
  const year = today.getUTCFullYear();
  const aepStart = new Date(`${year}-10-01T00:00:00Z`);
  const aepEnd = new Date(`${year}-12-07T23:59:59Z`);
  return today > aepStart && today < aepEnd;
}
